import React from 'react';
import moment from 'moment';
import api from 'api';
import { Spinner, AlertMessage } from 'hyperdb-utils';
import SearchForm from '../components/SearchForm';
import ListingTable from '../components/ListingTable';
import { ModalEmailAction } from '../../common';
import { generateReference } from '../../../../../backend/daily-rental/api/bookingFile';

class Listing extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickBack = this.handleClickBack.bind(this);
    this.handleChangeSearchParams = this.handleChangeSearchParams.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleClickCheckboxAll = this.handleClickCheckboxAll.bind(this);
    this.handleSelectItem = this.handleSelectItem.bind(this);
    this.handleClickOffer = this.handleClickOffer.bind(this);
    this.toggleModalAction = this.toggleModalAction.bind(this);
    this.handleConfirmSuggestProperties = this.handleConfirmSuggestProperties.bind(this);
    this.handleConfirmSendProposal = this.handleConfirmSendProposal.bind(this);
    this.handleConfirmSendOffer = this.handleConfirmSendOffer.bind(this);
    this._hasSearched = false;
  }
  componentDidMount() {
    this.props.api.availabilities.setData({ selectedItems: {} });
    if (this.props.location.search) {
      const reference = this.props.location.query.reference;
      if (reference) {
        this.props.api.availabilities.getData({
          url: `/get-related-object?reference=${reference}`,
          propName: 'relatedObject',
        });
      }
      const messageId = this.props.location.query.message_id;
      if (messageId) {
        this.props.api.message.getData({ url: `/${messageId}` })
          .then(relatedMessage => {
            this.props.api.availabilities.setData({ relatedMessage, messageReference: relatedMessage.related_object_reference || generateReference() });
            this.getCustomerFromRecipient(relatedMessage.sender)
              .then(customer => {
                this.props.api.availabilities.setData({ customer });
              })
          });
        this.props.api.message.getData({ url: `/${messageId}/content` })
          .then(content => {
            this.props.api.message.setData({ quotedMessage: content.body });
          });
      } else {
        this.props.api.availabilities.setData({ messageReference: generateReference() });
      }
      this.refreshListingFromUrl(this.props);
    } else {
      this.props.api.availabilities.setData({ messageReference: generateReference() });
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.refreshListingFromUrl(nextProps);
    }
    if (nextProps.selectedAction && nextProps.postDataSuccessful) {
      this.props.api.availabilities.setData({ postDataSuccessful: false, selectedAction: null });
      if (nextProps.selectedAction === 'suggest_properties') {
        if (nextProps.relatedObject) { // redirect to inquiry/reservation
          const entryPoint = nextProps.relatedObject._type === 'inquiry' ? 'inquiries' : 'reservations';
          return this.props.api.routing.redirect(this.props.router, `/daily-rental/${entryPoint}/${nextProps.relatedObject.id}`);
        }
        this.props.api.availabilities.setData({ successMessage: 'Email sent' });
      }
    }
  }
  componentWillUnmount() {
    this.props.api.availabilities.setData({
      selectedAction: null,
      relatedObject: null,
      selectedItems: {},
      allCheckboxesChecked: false,
      successMessage: null,
      errorMessage: null,
      selectedPropertyId: null,
      messageReference: null,
      customer: null,
    });
  }
  render() {
    let repliedMessageId;
    if (this.props.relatedMessage) repliedMessageId = this.props.relatedMessage.id;
    if (this.props.relatedObject) repliedMessageId = this.props.relatedObject.lastMessageId;
    let title;
    if (!this.props.location.query.reference) {
      title = 'Search availabilities';
    } else if (this.props.location.query.action === 'make_offer') {
      title = `Make offer for ${ this.props.location.query.reference }`;
    } else {
      title = `Suggest alternative for ${ this.props.location.query.reference }`;
    }
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <div className="row">
            <div className="col-md-7">
              {
                this.props.location.query.reference || this.props.location.query.message_id
                  ? <span className="btn btn-sm btn-primary" onClick={ this.handleClickBack }>
                      <i className="fas fa-chevron-left"></i> Back
                    </span>
                  : null
              }
              &nbsp;
              <h3 className="box-title">{ title }</h3>
            </div>
          </div>
        </section>
        <section className="content content-fixed">
          {
            this.props.errorMessage
              ? <AlertMessage
                  type="error"
                  onDismiss={ this.props.api.availabilities.dismissAlert }>
                    { this.props.errorMessage }
                </AlertMessage>
              : null
          }
          {
            this.props.successMessage
              ? <AlertMessage
                  type="success"
                  onDismiss={ this.props.api.availabilities.dismissAlert }>
                    { this.props.successMessage }
                </AlertMessage>
              : null
          }
          <div className="box box-body">
            <Spinner show={ this.props.loading } />
            <SearchForm
              { ...this.props.searchParams }
              loading={ this.props.loading }
              onChange={ this.handleChangeSearchParams }
              onSubmit={ this.handleSearch }
            />
            <br/><br/>
            {
              this._hasSearched && !this.props.loading && this.props.availabilities && this.props.availabilities.length === 0
                ? <div>No results</div>
                : null
            }
            {
              this._hasSearched && this.props.availabilities && this.props.availabilities.length > 0
                ? <ListingTable
                    { ...this.props }
                    sort={ this.getSort() }
                    onSort={ this.handleSort }
                    onClickCheckboxAll={ this.handleClickCheckboxAll }
                    onSelectItem={ this.handleSelectItem }
                    onClickSuggest={ this.toggleModalAction.bind(this, 'suggest_properties') }
                    onClickOffer={ this.handleClickOffer }
                  />
                : null
            }
          </div>
        </section>
        {
          !!this.props.selectedAction
            ? <ModalEmailAction
                { ...this.propsForModalAction() }
                canCreateCustomer={ !this.props.relatedObject }
                recipient={ this.props.relatedMessage ? this.props.relatedMessage.sender : null }
                repliedMessageId={ repliedMessageId }
                quoteRepliedMessage={ !!repliedMessageId }
                processingAction={ this.props.loading }
                selectedAction={ this.props.selectedAction }
                onClose={ this.toggleModalAction.bind(this, null) }
                actionSuccessful={ this.props.postDataSuccessful } />
            : null
        }
      </div>
    );
  }
  handleClickBack() {
    if (window.previousLocation) {
      this.props.router.push(window.previousLocation);
    } else if (this.props.location.query.message_id) {
      return this.props.api.routing.redirect(this.props.router, `/email/messages/${this.props.location.query.message_id}`);
    } else if (this.props.location.query.reference && this.props.relatedObject) {
      const entryPoint = this.props.relatedObject._type === 'inquiry' ? 'inquiries' : 'reservations';
      return this.props.api.routing.redirect(this.props.router, `/daily-rental/${entryPoint}/${this.props.relatedObject.id}`);
    }
  }

  refreshListingFromUrl(props) {
    this._hasSearched = true;
    const searchParams = { ...(props.location.query || {}) };
    this.props.api.availabilities.setData({ searchParams, selectedItems: {}, allCheckboxesChecked: false });
    searchParams.ignore_conditions = parseInt(searchParams.ignore_conditions || 0);
    let query = `?nb_adults=${searchParams.nb_adults}&nb_young_adults=${searchParams.nb_young_adults}&nb_children=${searchParams.nb_children}&nb_young_children=${searchParams.nb_young_children}`;
    query += `&arrival_date=${searchParams.arrival_date}&departure_date=${searchParams.departure_date}`;
    query += `&ignore_conditions=${searchParams.ignore_conditions}`;
    this.props.api.availabilities.getData({
      url: '/search' + query,
      propName: 'availabilities',
    });
  }
  handleChangeSearchParams(attributeName, field) {
    const searchParams = { ...this.props.searchParams, [attributeName]: field.value };
    this.props.api.availabilities.setData({ searchParams });
  }
  handleSearch() {
    const searchParams = this.props.searchParams || {};
    if (searchParams.arrival_date && searchParams.departure_date) {
      const queryParams = {
        arrival_date: searchParams.arrival_date,
        departure_date: searchParams.departure_date,
        nb_adults: searchParams.nb_adults || 0,
        nb_young_adults: searchParams.nb_young_adults || 0,
        nb_children: searchParams.nb_children || 0,
        nb_young_children: searchParams.nb_young_children || 0,
        ignore_conditions: searchParams.ignore_conditions ? 1 : 0,
      };
      const query = { ...this.props.location.query, ...queryParams };
      this.props.router.push({ ...this.props.location, query });
    }
  }

  getSort() {
    const sort = this.props.sort;
    if (!sort) return null;
    return sort.split('__');
  }
  handleSort(sort) {
    const query = { ...this.props.location.query, sort };
    this.props.api.availabilities.setData({ sort });
  }
  handleClickCheckboxAll() {
    const allCheckboxesChecked = !this.props.allCheckboxesChecked;
    const selectedItems = this.props.availabilities.reduce((result, availability) => {
      return { ...result, [availability.id]: allCheckboxesChecked };
    }, {});
    this.props.api.availabilities.setData({ allCheckboxesChecked, selectedItems });
  }
  handleSelectItem(id) {
    const checked = !this.props.selectedItems[id];
    const selectedItems = { ...this.props.selectedItems, [id]: checked };
    this.props.api.availabilities.setData({ selectedItems });
  }
  toggleModalAction(selectedAction) {
    this.props.api.availabilities.setData({ selectedAction, selectedPropertyId: null });
  }
  handleClickOffer(propertyId) {
    this.props.api.availabilities.setData({ selectedAction: 'make_offer', selectedPropertyId: propertyId });
  }

  getCustomerFromRecipient(recipient) {
    let primaryEmail;
    if (recipient.match('<')) {
      const [displayName, email] = recipient.split(' <');
      primaryEmail = email.split('>')[0];
    } else {
      primaryEmail = recipient;
    }
    const queryOptions = [
      ['id', 'name', 'language', ['entity', ['primary_email'] ]],
      { where: { 'entity.primary_email': primaryEmail } },
    ];
    return this.props.api.customer.getObjects({ queryOptions, notInStore: true })
      .then(res => {
        const customer = res.customers[0];
        const entity = res.entities[0];
        if (!customer) return null;
        return { ...customer, entity };
      });
  }

  propsForModalAction() {
    let templateCode;
    let title;
    let confirmMessage;
    let forceSendEmail = false;
    let onSubmit;
    let searchAvailabilities;
    const selectedItemsIds = Object.keys(this.props.selectedItems).filter(propertyId => !!this.props.selectedItems[propertyId] );
    switch (this.props.selectedAction) {
    case 'suggest_properties':
      if (this.props.location.query.reference) {
        templateCode = 116;
        title = 'Make a proposal';
        onSubmit = this.handleConfirmSuggestProperties;
      } else {
        templateCode = 105;
        title = 'Make a proposal';
        onSubmit = this.handleConfirmSendProposal;
      }
      forceSendEmail = true;
      searchAvailabilities = this.props.availabilities.filter(a => selectedItemsIds.includes(a.id));
      break;
    case 'make_offer':
      templateCode = 120;
      title = 'Make an offer';
      onSubmit = this.handleConfirmSendOffer;
      forceSendEmail = true;
      break;
    }
    let reservation;
    if (this.props.relatedObject) {
      reservation = { ...this.props.relatedObject };
    } else {
      reservation = { ...this.props.searchParams };
      reservation.nb_nights = moment(reservation.departure_date).diff(moment(reservation.arrival_date), 'days');
      reservation.nb_total_people = parseInt(reservation.nb_adults || 0) + parseInt(reservation.nb_young_adults || 0) + parseInt(reservation.nb_children || 0) + parseInt(reservation.nb_young_children || 0);
      reservation.price_not_communicated = true;
      if (this.props.customer) reservation.customer = this.props.customer;
    }
    // Select only 1 property
    if (selectedItemsIds.length === 1 || this.props.selectedPropertyId) {
      if (!this.props.selectedPropertyId) {
        templateCode = this.props.location.query.reference ? 117 : 105;
      }
      const propertyId = this.props.selectedPropertyId || selectedItemsIds[0];
      const alternativeProperty = this.props.availabilities.find(a => a.id === propertyId);
      reservation.property = alternativeProperty;
      reservation.nb_nights = alternativeProperty.nb_nights;
      reservation.nb_total_people = alternativeProperty.nb_total_people;
      reservation.price_not_communicated = false;
      reservation.base_price = alternativeProperty.base_price;
      reservation.base_price_per_night = alternativeProperty.base_price_per_night;
      reservation.vat = alternativeProperty.vat;
      reservation.vat_amount = alternativeProperty.vat_amount;
      reservation.cleaning_fee = alternativeProperty.cleaning_fee;
      reservation.tourist_tax = alternativeProperty.tourist_tax;
      reservation.total_price = alternativeProperty.total_price;
      reservation.total_price_without_tourist_tax = alternativeProperty.total_price_without_tourist_tax;
      reservation.total_price_per_night_per_person = alternativeProperty.total_price_per_night_per_person;
      if (this.props.selectedPropertyId) reservation.reference = this.props.messageReference;
    }
    return {
      reservation,
      templateCode,
      title,
      confirmMessage,
      forceSendEmail,
      onSubmit,
      searchAvailabilities,
    };
  }
  handleConfirmSuggestProperties({ message }) {
    const data = { message };
    if (this.props.relatedObject) {
      data.reference = this.props.relatedObject.reference;
      data.type = this.props.relatedObject._type;
    }
    this.props.api.availabilities.postData({
      url: '/send-suggest-email',
      data,
    });
  }
  handleConfirmSendProposal({ message }) {
    const data = { message };
    if (message.recipient) {
      if (this.props.relatedMessage) {
        data.message.related_object_reference = this.props.relatedMessage.related_object_reference || generateReference(this.props.relatedMessage.id);
        data.message.related_object_type = 'conversation';
        data.message.subject = `[MSG#${data.message.related_object_reference}] ${data.message.subject}`;
      }
      this.props.api.availabilities.setData({ loading: true });
      this.props.api.message.postData({ url: '/send', data })
        .then(() => {
          this.props.api.availabilities.setData({ loading: false });
          this.props.api.message.setData({ successMessage: 'Proposal sent' });
          this.props.api.routing.redirect(this.props.router, `/email/messages/${this.props.location.query.message_id}`);
        })
        .catch(err => {
          this.props.api.message.setData({ errorMessage: err.message || err });
        });
    }
  }
  handleConfirmSendOffer({ message }) {
    if (message.recipient) {
      const { arrival_date, departure_date, nb_adults, nb_young_adults, nb_children, nb_young_children, nb_babies } = this.props.searchParams;
      const reservation = {
        status: 'offered',
        arrival_date,
        departure_date,
        nb_adults,
        nb_young_adults,
        nb_children,
        nb_young_children,
        nb_babies,
        property_id: this.props.selectedPropertyId,
        reference: this.props.messageReference,
        creation_date: moment().format('YYYY-MM-DD HH:mm:ss ZZ'),
        origin: 'PMS',
        ignore_conditions: this.props.searchParams.ignore_conditions,
      };
      const entity = {};
      if (message.recipient.match('<')) {
        const [displayName, email] = message.recipient.split(' <');
        entity.display_name = displayName;
        if (displayName.match(' ')) {
          const [fistName, lastName] = /^([^\s]+)\s(.*)$/.exec(displayName).slice(1);
          entity.first_name = fistName;
          entity.last_name = lastName;
        } else {
          entity.first_name = displayName;
        }
        entity.primary_email = email.split('>')[0];
      } else {
        entity.primary_email = message.recipient;
      }
      const data = {
        reservations: [reservation],
        customers: [{ language: message.language || 'en' }],
        entities: [entity]
      };
      this.props.api.availabilities.setData({ loading: true });
      this.props.api.reservation.postData({ url: '/', data })
        .then(savedReservation => {
          console.log('savedReservation', savedReservation);
          return this.props.api.reservation.postData({ url: `/${savedReservation.id}/send-email`, data: { message } })
          .then(() => {
            console.log('email sent');
            this.props.api.availabilities.setData({ loading: false });
            this.props.api.message.setData({ successMessage: 'Offer sent' });
            this.props.api.routing.redirect(this.props.router, `/daily-rental/reservations/${savedReservation.id}`);
          });
        })
        .catch(err => {
          this.props.api.message.setData({ errorMessage: err.message || err });
        });
    }
  }
}

export default api.connect(Listing, 'availabilities');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/availabilities/containers/Listing.jsx